module.exports = __webpack_public_path__ + "img/4_4.582d5182.png";